import React from "react";
import styles from "./Box.module.scss";
import { fav, favDisabled } from "assets/images";
import go from "assets/img/iconRight.png";
import phone from "assets/img/phone.png";
import { calculateDistance, pin } from "assets/helpers";
import { isMobileDevice } from "shared/mobileHelpers";

const imagesPath = {
    minus: fav,
    plus: favDisabled
};

class Box extends React.Component {
    state = {
        open: true
    };

    getInitialState() {
        return { showResults: false };
    }

    lowerCase(str) {
        return str.toLowerCase();
    }

    distanceFromMe(item) {
        const estabelecimentoLatLng = {
            lat: item.LATITUDE,
            lng: item.LONGITUDE
        };
        const distance = calculateDistance(
            estabelecimentoLatLng,
            this.props.userLocation
        );

        if (distance > 1000) {
            return `${(distance / 1000).toFixed(1)} kms`;
        } else {
            return `${distance.toFixed(0)} metros`;
        }
    }

    showOnMap(item) {
        this.props.setZoom(17)
        this.props.setSelectedEstabelecimento(item);
    }

    handleGo = () => {
        if (isMobileDevice.iOS()) {
            // mandar lat lng p/ google
            window.open(
                `maps://maps.google.com/maps?saddr=${this.props.userLocation.lat},${this.props.userLocation.lng}&daddr=${this.props.item.LATITUDE},${this.props.item.LONGITUDE}&amp;ll=`
            );
        } else {
            window.open(
                `https://maps.google.com/maps?saddr=${this.props.userLocation.lat},${this.props.userLocation.lng}&daddr=${this.props.item.LATITUDE},${this.props.item.LONGITUDE}&amp;ll=`
            );
        }
    };

    render() {
        const { item, estabelecimentosFavoritos = [] } = this.props;

        const isFavorite =
            estabelecimentosFavoritos.find(el => el.ID === item.ID) !==
            undefined;
        return (
            <div className={styles.box}>
                <div className={styles.header}>
                    <div className={styles.iconBorder}>
                        <img
                            src={pin(item.NOVA_CATEGORIA)}
                            alt=""
                            className={styles.iconImage}
                        />
                    </div>
                    <div className={styles.name}>
                        {this.lowerCase(item.NOME_REDUZIDO)}
                    </div>
                </div>
                <div className={styles.address}>
                    {this.lowerCase(item.LOGRADOURO)} {item.NUMERO},{" "}
                    {this.lowerCase(item.NOME_CIDADE)} <br></br>
                    {item.TELEFONE_COMERCIAL}
                    <span className={styles.distance}>
                        <b>{this.distanceFromMe(item)}</b> de mim
                    </span>
                </div>
                <div className={styles.footer}>
                    <div
                        className={styles.fav}
                        onClick={() => {
                            this.props.favoritar(item);
                        }}
                    >
                        <img
                            alt="Favoritar"
                            className={styles.favImage}
                            src={imagesPath[isFavorite ? "minus" : "plus"]}
                        />
                    </div>
                    <div className={styles.phoneBox}>
                        <img
                            alt="Ligação"
                            className={styles.phoneIcon}
                            src={phone}
                        />
                    </div>
                    <div className={styles.linkToMap} onClick={this.handleGo}>
                        Ir
                    </div>
                    <div
                        className={styles.pinMap}
                        onClick={this.showOnMap.bind(this, item)}
                    >
                        Ver no mapa
                        <img alt="Ver no mapa" className={styles.go} src={go} />
                    </div>
                </div>
            </div>
        );
    }
}
export default Box;
